import React, { useContext, useEffect } from "react";
import Sidebar from "../dashboard/sidebar/Sidebar";
import Header from "../dashboard/header/Header";
import { LanguageContext } from "../../context/LanguageContext";

const MainLayout = ({ children }) => {
  const { setLang } = useContext(LanguageContext);
  useEffect(() => {
    setLang("en");
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="flex h-screen">
      <Sidebar />
      <div className="flex flex-col flex-1">
        <Header />
        <main className="flex-1 p-4 bg-gray-100 overflow-y-auto">
          {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
